import { localStorage as localStorageConstants } from 'constants/index';
import * as checkUrl from 'utils/checkUrl';
export const getProvider = () => {
    return localStorage.getItem(localStorageConstants.PROVIDER);
};
export const isSnsFlagOn = () => {
    return localStorage.getItem(localStorageConstants.SNS_FLG) === localStorageConstants.SNS_FLG_ON;
};
/**
 * 現在利用中のアカウントが新規登録が確認する。
 * true: 利用中のSNSアカウントは新規登録中
 * false: 利用中のSNSアカウントはすでに新規登録済み
 */
export const isSnsNewUserRegisteringing = () => {
    return (localStorage.getItem(localStorageConstants.SNS_NEW_USER_REGISTERING_FLAG) ===
        localStorageConstants.SNS_NEW_USER_REGISTERING_FLAG_ON);
};
export const setSnsNewUserRegisteringFlagOn = () => {
    localStorage.setItem(localStorageConstants.SNS_NEW_USER_REGISTERING_FLAG, localStorageConstants.SNS_NEW_USER_REGISTERING_FLAG_ON);
};
export const removeSnsNewUserRegisteringFlag = () => {
    localStorage.removeItem(localStorageConstants.SNS_NEW_USER_REGISTERING_FLAG);
};
/**
 * SNS連携でログイン成功した際のみ、UIを可変に対応するためにSNS連携ログイン中の状態を保存する
 * 使用箇所：プロフィールのメール入力欄の非活性
 */
export const setSnsUserFlagOn = () => {
    localStorage.setItem(localStorageConstants.SNS_USER_FLAG, localStorageConstants.SNS_USER_FLAG_ON);
};
export const removeSnsUserFlag = () => {
    localStorage.removeItem(localStorageConstants.SNS_USER_FLAG);
};
export const isSnsUserFlagOn = () => {
    return (localStorage.getItem(localStorageConstants.SNS_USER_FLAG) ===
        localStorageConstants.SNS_USER_FLAG_ON);
};
export const isAppleLogin = () => {
    return getProvider() === 'apple';
};
export const isGoogleLogin = () => {
    return getProvider() === 'google';
};
export const isPasswordFlagOn = () => {
    return (localStorage.getItem(localStorageConstants.PASSWORD_FLG) ===
        localStorageConstants.SNS_PASSWORD_ON);
};
export const getDefaultNotSetJpConversationLevel = () => {
    return localStorage.getItem(localStorageConstants.DEFAULT_NOT_SET_JAPANESE_CONVERSACTION_LEVEL_KEY);
};
export const isAppleNameEmptyCheck = () => {
    return localStorage.getItem(localStorageConstants.TEACHER_APPLE_NAME_FLG_KEY) !== null;
};
export const isGoogleFirstLogin = () => {
    return localStorage.getItem(localStorageConstants.TEACHER_IS_FIRST_GOOGLE_LOGIN) !== null;
};
export const snsAllFlagsRemove = () => {
    localStorage.removeItem(localStorageConstants.SNS_FLG);
    localStorage.removeItem(localStorageConstants.SNS_NEW_USER_REGISTERING_FLAG);
    localStorage.removeItem(localStorageConstants.SNS_USER_FLAG);
    localStorage.removeItem(localStorageConstants.PROVIDER);
    localStorage.removeItem(localStorageConstants.PASSWORD_FLG);
};
export const openConfirmTermsModal = (searchParams) => {
    if (searchParams.has('sns_show_confirm_term')) {
        localStorage.setItem(localStorageConstants.SNS_FLG, localStorageConstants.SNS_FLG_ON);
        return true;
    }
    else
        return false;
};
export const openFailSnsSignupModal = (searchParams) => {
    return searchParams.has('sns_not_include_email');
};
export const openFailUserTypeSnsSignup = (searchParams) => {
    return searchParams.has('user_type_diff') || searchParams.has('sns_uid_diff_email_same');
};
export const tokenExistcheck = (searchParams) => {
    if (searchParams.has('auth_token') &&
        searchParams.has('web_socket_token') &&
        searchParams.get('auth_token') !== '' &&
        searchParams.get('web_socket_token') !== '') {
        const auth_token = searchParams.get('auth_token') || '';
        const web_socket_token = searchParams.get('web_socket_token') || '';
        const email = searchParams.get('email') || '';
        if (checkUrl.isStudents()) {
            localStorage.setItem(localStorageConstants.STUDENTS_AUTH_TOKEN_KEY, auth_token);
        }
        else {
            localStorage.setItem(localStorageConstants.TEACHERS_AUTH_TOKEN_KEY, auth_token);
        }
        localStorage.setItem(localStorageConstants.WEB_SOCKET_TOKEN_KEY, web_socket_token);
        localStorage.setItem(localStorageConstants.USERS_EMAIL, email);
        return true;
    }
    else
        return false;
};
export const snsNewUsercheck = (searchParams) => {
    if (searchParams.has('sns_new_user') && searchParams.get('sns_new_user') === 'false') {
        localStorage.setItem(localStorageConstants.SNS_FLG, localStorageConstants.SNS_FLG_OFF);
        return false;
    }
    else
        return true;
};
export const userPasswordFlagcheck = (searchParams) => {
    if (searchParams.has('user_password_flag') && searchParams.get('user_password_flag') === 'true') {
        localStorage.setItem(localStorageConstants.PASSWORD_FLG, localStorageConstants.SNS_PASSWORD_ON);
    }
};
